import { handleActions } from 'redux-actions';

const initialState = {
  // default API
  modals: {
    feed: { show: false, feed: null },
    account: { show: false }
  }
};

export default handleActions({
  SHOW_FEED_DOWNLOAD_MODAL(state, { payload }) {
    return Object.assign({}, state, {
      modals: Object.assign({}, state.modals, {
        feed: { show: true, feed: payload.feed }
      })
    })
  },

  SHOW_ACCOUNT_DOWNLOAD_MODAL(state) {
    return Object.assign({}, state, {
      modals: Object.assign({}, state.modals, {
        account: { show: true }
      })
    })
  },

  HIDE_FEED_DOWNLOAD_MODAL(state) {
    return Object.assign({}, state, {
      modals: Object.assign({}, state.modals, {
        feed: { show: false, feed: null }
      })
    })
  },

  HIDE_ACCOUNT_DOWNLOAD_MODAL(state) {
    return Object.assign({}, state, {
      modals: Object.assign({}, state.modals, {
        account: { show: false }
      })
    })
  },
}, initialState);
